














import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class OptionList extends Vue {

  @Prop({ default: '',  type: String}) prefix!:string;
  @Prop({ default: [],  type: Array}) options!:string[];
  @Prop({ default: '',  type: String}) curOption!:string;
  
  mounted() {
    // nothing yet
  }

  optionChanged(newOption:string) {
    this.$emit('option-change', newOption);
  }
}

